
import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup,
    Label, Input, InputGroup, InputGroupAddon, Button, CustomInput
} from 'reactstrap';

import { alertService } from 'components/Varios/alert_service.js';
import Icon from "components/Varios/Icons.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import CardIdiomas from "components/Varios/CardIdiomas.js";

//import FileUpload from "components/Varios/FileUpload.js";
//import FileDownload from "components/Varios/FileDownload.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../services/authentication.service';

const id = 1043;
const API_URL = configData.SERVER_URL

export class IdiomasData {
    ididiomapersona: number = 0;
    idpersona: number = 0;
    ididioma: number = 0;
    descripcion: string = "";
    lenguanativa: string = "";
    nivelconversacion: string = "";
    nivelescritura: string = "";
    nivellectura: string = "";

    refarchivo: string = "";
}


interface IdiomasDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: IdiomasData;
    IdiomasDataList: IdiomasData[];
    idiomasList: Array<any>;
    nivelList: Array<any>;
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
}

export class Idiomas extends React.Component<RouteComponentProps<{}>, IdiomasDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true, dtoData: new IdiomasData(),
            IdiomasDataList: [], idiomasList: [], nivelList: [], error: null, tiposEvidencia: [], filesData: []
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarIdiomas = this.cargarIdiomas.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarIdiomas();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        //API PARA OBTENER IDIOMAS
        fetch(API_URL + "InformacionAcademica/Idiomas")
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        this.setState({
                            idiomasList: result.entTabla.map(d => ({
                                "value": d.ididioma,
                                "label": d.idioma
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        idiomasList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER NIVELES DE IDIOMA
        fetch(API_URL + "InformacionAcademica/InformacionAcademicaCatalogo/NIVEL IDIOMA")
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        this.setState({
                            nivelList: result.entTabla.map(d => ({
                                "value": d.codigostr.trim(),
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los paises.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        nivelList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    //API PARA OBTENER INFORMACIÓN ACADÉMICA DE PERSONA
    cargarIdiomas() {
        fetch(API_URL + "InformacionAcademica/IdiomasDescByIdpersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            IdiomasDataList: result.entTabla,
                            loading: false,
                            loadingList: false,
                            tiposEvidencia: this.cargarEvidencias(filesData)
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los idiomas.")
                    }
                },
                (error) => {
                    
                    this.setState({
                        loading: false,
                        error,
                        IdiomasDataList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;

        if (name === "idnomenclaturatit") {
            dto["strcampodetallado"] = value;
        }

        this.setState({
            dtoData: dto,
        });
    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);

        this.setState({
            filesData: fileInfoState,
        });

    }

    cargarEvidencias(filesData: any[]) {
        var tiposEvidencia = [
            { "value": "IDI", "label": "Certificado de idioma" + filesData.filter(f => f.type == "IDI").map(ff => ': ' + ff.file.name).join(', ') },
        ];
        //console.log("cargarEvidencias: tiposEvidencia=" + tiposEvidencia.map(te => te.value + " => " + te.label).join(", "));
        return tiposEvidencia;
    }

    descargarEvidencias(infoAcademica: IdiomasData) {
        var evidencias = new Array();
        if (infoAcademica.refarchivo) {
            evidencias.push({ name: "IDI" + this.state.currentUser.identificacion + "-" + infoAcademica.ididioma + ".PDF", url: API_URL + "InformacionAcademica/Idiomas/Refarchivo/" + infoAcademica.ididiomapersona });
        }
        return evidencias;
    }

    onClickLimpiar() {
        this.setState({ dtoData: new IdiomasData() });
    }

    onClickEdit(ididiomapersona) {
        this.setState({
            dtoData: new IdiomasData()
        });

        fetch(API_URL + "InformacionAcademica/IdiomaByIdidiomapersona/" + ididiomapersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;
                        this.setState({
                            dtoData: result.entTabla[0],
                            tiposEvidencia: this.cargarEvidencias(filesData),
                            loading: false
                        });

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);

                    } else {
                        alertService.error(result["strMensaje"])
                    }

                },
                (error) => {
                    
                    this.setState({
                        loading: false,
                        error,
                        dtoData: new IdiomasData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(ididiomapersona) {
        fetch(API_URL + "FormularioController/DeleteDatosIdiomaPersona/" + ididiomapersona, {

            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },

        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("El idioma se eliminó correctamente.")
                        this.cargarIdiomas();
                    }
                })
    }

    private postFiles(postFilesUrl, filesData, identidad) {
        //console.log("filesData = " + JSON.stringify(filesData));
        
    }

    private handleSave(event) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        let formIsValid = true;
        let errors = "";

        forma.forEach((value, clave) => {
            if (!value && clave !== "evidencias") {
                formIsValid = false;
                errors = "Por favor seleccione todos los campos. "
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;
        });

        if (dto.lenguanativa === "") {
            formIsValid = false;
            errors = " Por favor complete la información de todos los campos obligatorios (*). "
        }

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "entidad": dto,
        });

        if (formIsValid) {
            if (dto.ididiomapersona === 0) {
                fetch(API_URL + "FormularioController/PostDatosIdiomaPersona", {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error("Ocurrió un error: " + responseJson["strMensaje"])
                            }
                            else if (responseJson["strEstado"] === "S") {

                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                                if (filesData.length > 0) {
                                    var formFilesData = new FormData();

                                    filesData.map((fileData) => {
                                        formFilesData.append("files", fileData.file, fileData.file.name);
                                    });

                                    formFilesData.append('identidad', responseJson.entidad.ididiomapersona);

                                    fetch(API_URL + "FormularioController/PostFilesDatosEscalafon/Idiomas", {
                                        method: 'POST',
                                        body: formFilesData
                                    })
                                        .then(response => response.json())
                                        .then(
                                            (responseJson) => {
                                                if (responseJson["strEstado"] === "S") {
                                                    alertService.success("El idioma se ha registrado correctamente.");
                                                    this.onClickLimpiar();
                                                    this.cargarIdiomas();
                                                }
                                                else {
                                                    alertService.error(responseJson["strMensaje"])
                                                }
                                            })
                                        .catch(error => alertService.error(error)
                                        );
                                }
                                else {
                                    alertService.success("El idioma se ha registrado correctamente.");
                                    this.onClickLimpiar();
                                    this.cargarIdiomas();
                                }
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosIdiomaPersona", {

                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,

                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])
                            }
                            else if (responseJson["strEstado"] === "S") {

                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                                if (filesData.length > 0) {
                                    var formFilesData = new FormData();

                                    filesData.map((fileData) => {
                                        formFilesData.append("files", fileData.file, fileData.file.name);
                                    });

                                    formFilesData.append('identidad', responseJson.entidad.ididiomapersona);

                                    fetch(API_URL + "FormularioController/PostFilesDatosEscalafon/Idiomas", {
                                        method: 'POST',
                                        body: formFilesData
                                    })
                                        .then(response => response.json())
                                        .then(
                                            (responseJson) => {
                                                if (responseJson["strEstado"] === "S") {
                                                    alertService.success("El idioma se ha actualizado correctamente.");
                                                    this.onClickLimpiar();
                                                    this.cargarIdiomas();
                                                }
                                                else {
                                                    alertService.error(responseJson["strMensaje"])
                                                }
                                            })
                                        .catch(error => alertService.error(error)
                                        );
                                }
                                else {
                                    alertService.success("El idioma se ha actualizado correctamente.");
                                    this.onClickLimpiar();
                                    this.cargarIdiomas();
                                }
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }

                        }
                        , (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        }
                    )


            }
        }
        else {
            alertService.error("Ocurrió un error: " + errors);
        }

    }

    public render() {

        let contents = this.state.loading

            ? <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.IdiomasDataList, this.state.idiomasList, this.state.nivelList, this.state.tiposEvidencia);
        return <div className="content">

            {contents}

        </div>;

    }

    // Returns the HTML Form to the render() method.  

    private renderForm(IdiomasDataList: Array<any>, idiomasList: Array<any>, nivelList: Array<any>, tiposEvidencia: Array<any>) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">IDIOMAS</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>
                                    <form onSubmit={this.handleSave}>
                                        <Row form>
                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label for="tipoidentificacion">Lengua nativa*</Label>
                                                    <Row>
                                                        <Col md={5}>
                                                            <CustomInput
                                                                className="col-md-5 ml-1"
                                                                type="radio"
                                                                checked={this.state.dtoData.lenguanativa === "S"}
                                                                value="S"
                                                                id="lenguanativa"
                                                                name="lenguanativa"
                                                                onChange={this.handleChange}
                                                                label="Sí"
                                                            />
                                                        </Col>
                                                        <Col md={5}>
                                                            <CustomInput
                                                                className="col-md-6"
                                                                type="radio"
                                                                value="N"
                                                                id="lenguanativa2"
                                                                name="lenguanativa"
                                                                checked={this.state.dtoData.lenguanativa === "N"}
                                                                onChange={this.handleChange}
                                                                label="No"
                                                            />
                                                        </Col>
                                                    </Row>

                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label for="ididioma">Idioma*</Label>
                                                    <SelectItem
                                                        options={idiomasList}
                                                        value={this.state.dtoData.ididioma}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="ididioma"
                                                        id="ididioma"
                                                        icon="fa-caret-right"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            {(
                                                this.state.dtoData.ididioma === 10 ?
                                                    <Col md={4}>
                                                        <FormGroup>
                                                            <Label for="descripcion">Otro idioma*</Label>
                                                            <Input maxLength="20" type="text" name="descripcion" id="descripcion" value={this.state.dtoData.descripcion} onChange={this.handleChange} required />
                                                        </FormGroup>
                                                    </Col>
                                                    :
                                                    null
                                            )}
                                            <Col md={4}>
                                                <Label for="nivellectura">Nivel lectura*</Label>
                                                <SelectItem
                                                    options={nivelList}
                                                    value={this.state.dtoData.nivellectura}
                                                    onChange={this.handleSelectChange}
                                                    placeholder=""
                                                    name="nivellectura"
                                                    id="nivellectura"
                                                    icon="fa-caret-right"
                                                />
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label for="nivelescritura">Nivel escritura*</Label>
                                                    <SelectItem
                                                        options={nivelList}
                                                        value={this.state.dtoData.nivelescritura}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="nivelescritura"
                                                        id="nivelescritura"
                                                        icon="fa-caret-right"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <FormGroup>
                                                    <Label for="nivelconversacion">Nivel conversación*</Label>
                                                    <SelectItem
                                                        options={nivelList}
                                                        value={this.state.dtoData.nivelconversacion}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="nivelconversacion"
                                                        id="nivelconversacion"
                                                        icon="fa-caret-right"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={4}>
                                                <Label for="fechagraduacion">Evidencia</Label>
                                                <FormGroup row>
                                                    <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                        <InputFileUpload
                                                            icon="upload"
                                                            onChange={this.handleFileUploadChange}
                                                            name="IDI"
                                                            placeholder={this.state.dtoData.refarchivo ? "Actualizar Certificado de idioma" : "Subir Certificado de idioma"} />
                                                    </Col>
                                                    <InputFileDownload tipo="certificado de idioma"
                                                        id="downloadRef"
                                                        refarchivo={this.state.dtoData.refarchivo}
                                                        name={"IDI" + this.state.currentUser.identificacion + "-" + this.state.dtoData.ididioma + ".PDF"}
                                                        url={API_URL + "InformacionAcademica/Idiomas/Refarchivo/" + this.state.dtoData.ididiomapersona}
                                                    />
                                                </FormGroup>
                                            </Col>

                                        </Row>

                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                                    <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>


                                    </form >
                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>
                                        </div>
                                        :
                                        <Row id="lista">
                                            {IdiomasDataList.map((dto, index) =>
                                                <CardIdiomas
                                                    key={dto.ididiomapersona}
                                                    objeto={dto}
                                                    evidencias={this.descargarEvidencias(dto)}
                                                    number={(index + 1) + " / " + IdiomasDataList.length}
                                                    eventEdit={() => this.onClickEdit(dto.ididiomapersona)}
                                                    eventDelete={() => this.onClickDelete(dto.ididiomapersona)}
                                                />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default Idiomas;